export default "__VITE_ASSET__B8yTfA1C__"